/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5b029cb3"]'><cube-button-group><cube-button primary>确认按钮</cube-button></cube-button-group></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5b029cb3"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5b029cb3"}
  /** script content **/
  require("./button-group-one.mpx.js?isComponent&outputPath=components%2Fbutton-group-one5b029cb3%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./button-group-one.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbutton-group-one5b029cb3%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5b029cb3"],
    ctorType: "component",
    outputPath: "components/button-group-one5b029cb3/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>